module.exports = __webpack_public_path__ + "static/img/n-clock-add.871b84e5.png";